import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';

export const InvalidDeliveryFloorModal = (props: AlertProps) => (
    <Alert
        {...props}
        title="Ошибка в адресе доставки"
        description="Пожалуйста, укажите этаж для доставки"
        button={
            <DrawerBottomFixed>
                <DrawerButton onClick={props.onClose}>Закрыть</DrawerButton>
            </DrawerBottomFixed>
        }
    />
);
